import { requestBuilder } from '../../http/RequestBuilder';
import {
    type AccountCategory,
    type AccountSummary,
} from '../types/HolisticSummary';

interface UseUpdateQuilttAccountBody {
    userId: string;
    remoteId: string;
    name: string;
    holisticCategory: AccountCategory;
    minimumPayment?: number | null;
    interestRate?: number | null;
    description?: string | null;
    entireBalancePaidMonthly?: boolean | null;
}

const useUpdateQuilttAccount = requestBuilder.mutation<
    AccountSummary,
    UseUpdateQuilttAccountBody
>({
    endpoint: '/api/holistic/update-account',
    method: 'PATCH',
});

export default useUpdateQuilttAccount;
